<template>
  <div class="UsLicenses-container">
    <div class="title-content">
      <img src="./../assets/image/licenses-icon.png" class="title-logo" @click="goHome" />
    </div>
    <div class="title-us">
      <div class="us-text">US Licenses</div>
    </div>
    <div class="list-box">
      <div class="list-title">Alchemy Pay Inc is licensed in the following U.S. jurisdictions.</div>
      <div class="item-list">
        <div class="item-row">
          <div>Jurisdiction</div>
          <div>License Number</div>
          <div>Regulatory Agency</div>
        </div>

        <div class="item-row">
          <div>Arizona</div>
          <div>2449570</div>
          <div>Department of Insurance and Financial Institutions</div>
        </div>

        <div class="item-row">
          <div>Arkansas</div>
          <div>131437</div>
          <div>Arkansas Securities Department</div>
        </div>

        <div class="item-row">
          <div>Delaware</div>
          <div>2449570</div>
          <div>Delaware Check Seller, Money Transmitter License</div>
        </div>

        <div class="item-row">
          <div>Kansas</div>
          <div>2449570</div>
          <div>Kansas Money Transmitter License</div>
        </div>

        <div class="item-row">
          <div>Illinois</div>
          <div>2449570</div>
          <div>Illinois Money Transmitter License</div>
        </div>
        <div class="item-row">
          <div>lowa</div>
          <div>2023-0136</div>
          <div>State of lowa Division of Banking</div>
        </div>
        <div class="item-row">
          <div>Maine</div>
          <div>2449570</div>
          <div>Maine Money Transmitter License</div>
        </div>
        <div class="item-row">
          <div>Minnesota</div>
          <div>MN-MT-2449570</div>
          <div>Minnesota Department of Commerce, Financial Institutions Division</div>
        </div>
        <div class="item-row">
          <div>Nebraska</div>
          <div>2449570</div>
          <div>Nebraska Money Transmitter License</div>
        </div>

        <div class="item-row">
          <div>New Hampshire</div>
          <div>27020-MT</div>
          <div>New Hampshire Banking Department</div>
        </div>
        <div class="item-row">
          <div>New Mexico</div>
          <div>N/A</div>
          <div>New Mexico Financial Institutions Division</div>
        </div>
        <div class="item-row">
          <div>Oklahoma</div>
          <div>N/A</div>
          <div>Oklahoma Banking Department</div>
        </div>
        <div class="item-row">
          <div>Oregon</div>
          <div>N/A</div>
          <div>Oregon Division of Financial Regulation</div>
        </div>
        <div class="item-row">
          <div>Rhode Island</div>
          <div>2449570</div>
          <div>Rhode Island Currency Transmitter License</div>
        </div>
        <div class="item-row">
          <div>South Carolina</div>
          <div>2449570</div>
          <div>South Carolina Money Service Division</div>
        </div>
        <div class="item-row">
          <div>South Dakota</div>
          <div>2449570</div>
          <div>South Dakota Money Transmitter License</div>
        </div>
        <div class="item-row">
          <div>West Virginia</div>
          <div>2449570</div>
          <div>West Virginia Division of Financial Institutions</div>
        </div>
        <div class="item-row">
          <div class="Iowa">Wyoming</div>
          <div class="Iowa">7360</div>
          <div class="Iowa">Department of Audit</div>
        </div>
      </div>
    </div>
    <div class="state-content">
      <div class="state-title">State Disclosures:</div>
      <div class="state-text-box">
        <div class="text-title">Arkansas</div>
        <div>
          If you have a complaint, please contact Alchemy Pay Inc at +1(866)584-9768 or
          <a class="link-style" href="mailto:Contact@allins.io" target="_blank">info@alchemypay.org.</a>
        </div>
        <div>You may also contact Arkansas Securities Department if your complaints or disputes regarding Alchemy Pay Inc money transmission services remains</div>
        <div>
          unsolved, you may file a complaint with the Arkansas Security Department by clicking
          <a class="link-style" href="https://securities.arkansas.gov/file-a-complaint-2/" target="_blank">here.</a>
          You may also fill out the
          <a class="link-style" href="https://securities.arkansas.gov/wp-content/uploads/2022/07/ComplaintForm-July-2022.pdf" target="_blank">complaint form</a>
          and email to
        </div>
        <div>ASDInfo@securities.arkansas.gov or mail to the Arkansas Security Department at:</div>
        <div class="bottom-text">
          <div>1 COMMERCE WAY, SUITE 402</div>
          <div>LITTLE ROCK, ARKANSAS 72202</div>
          <div>TELEPHONE: (501) 324-9260</div>
          <div>FACSIMILE: (501) 324-9268</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  data() {
    return {};
  },
  components: {
    Footer,
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
  mounted() {},
  destroyed() {},
  created() {},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1180px) {
  .title-content {
    height: 100px;
    padding: 31px 0 35px 20px;
    box-sizing: border-box;
    background: #fff;
  }
  .title-logo {
    width: 149px;
    height: 24px;
    object-fit: cover;
    cursor: pointer;
  }
  .title-us {
    width: 100%;
    height: 100px;
    color: #fff;
    text-align: center;
    background: #000;
  }
  .us-text {
    font-family: "Bold";
    font-size: 24px;
    line-height: normal;
    padding-top: 30px;
  }
  .list-box {
    margin: 36px auto 0 auto;
  }
  .list-title {
    font-family: "Bold";
    font-size: 20px;
    color: #000;
    margin-left: 16px;
    margin-right: 16px;
  }
  .item-list {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 20px 16px 0 16px;
  }
  .item-row {
    width: 100%;
    display: flex;
    align-items: center;
    font-family: "Medium";
    font-size: 11px;
    color: #525868;
    border-top: 1px solid var(--1, #ccd2e2);
  }
  .Iowa {
    border-bottom: 1px solid var(--1, #ccd2e2);
  }
  .item-row div:nth-child(1) {
    width: 33.33%;
    height: 48px;
    line-height: 48px;
    border-left: 1px solid var(--1, #ccd2e2);
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(2) {
    width: 33.33%;
    height: 48px;
    line-height: 48px;
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(3) {
    width: 33.33%;
    height: 48px;
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .state-content {
    margin: 36px 16px 0 16px;
    padding-bottom: 36px;
  }
  .state-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
    margin-bottom: 34px;
  }
  .state-text-box {
    font-size: 16px;
    color: #525868;
    font-family: "Medium";
    line-height: 40px;
  }
  .text-title {
    margin-bottom: 35px;
  }
  .bottom-text {
    margin-top: 34px;
  }
  .link-style {
    color: #0b48e6;
  }
  .link-style:hover {
    text-decoration: none;
    border-bottom: 1.5px solid blue;
  }
}
@media (min-width: 1180px) and (max-width: 10000px) {
  .title-content {
    height: 100px;
    padding: 31px 0 35px 77px;
    box-sizing: border-box;
    background: #fff;
  }
  .title-logo {
    width: 211px;
    height: 34px;
    object-fit: cover;
    cursor: pointer;
  }
  .title-us {
    width: 100%;
    height: 200px;
    color: #fff;
    text-align: center;
    background: #000;
  }
  .us-text {
    font-family: "Bold";
    font-size: 60px;
    line-height: normal;
    padding-top: 59px;
  }
  .list-box {
    width: 1180px;
    margin: 80px auto 0 auto;
  }
  .list-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
  }
  .item-list {
    border: 1px solid var(--1, #ccd2e2);
    border-bottom: none;
    margin-top: 40px;
  }
  .item-row {
    display: flex;
    align-items: center;
    font-family: "Medium";
    font-size: 16px;
    color: #525868;
  }
  .item-row div:nth-child(1),
  .item-row div:nth-child(2) {
    width: 260px;
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid var(--1, #ccd2e2);
    border-right: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .item-row div:nth-child(2) {
  }
  .item-row div:nth-child(3) {
    // width: 393px;
    flex: 1;
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid var(--1, #ccd2e2);
    text-align: center;
  }
  .state-content {
    width: 1180px;
    margin: 60px auto 0 auto;
    padding-bottom: 80px;
  }
  .state-title {
    font-family: "Bold";
    font-size: 24px;
    color: #000;
    margin-bottom: 34px;
  }
  .state-text-box {
    font-size: 16px;
    color: #525868;
    font-family: "Medium";
    line-height: 40px;
  }
  .text-title {
    margin-bottom: 35px;
  }
  .bottom-text {
    margin-top: 34px;
  }
  .link-style {
    color: #0b48e6;
  }
  .link-style:hover {
    text-decoration: none;
    border-bottom: 1.5px solid blue;
  }
}
</style>
